import PostbackActions from '../../../../actions/PostbackActions';

export const actions = {
    getPostbackParameters(params = {}) {
        PostbackActions.getPostbackParameters(params);
    }
};
